import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';

import useClickOutside from '@hooks/useClickOutside';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getSampleCountryList } from '@services/designInfoUpdateService';

import { printApiError } from '@utils/Util';

const SampleLocationDetailsModal = ({
	onClose,
	selectedLocationsToDownload,
	downloadReportByProductIds,
	setSelectedLocationsToDownload,
	selectedProductIds = []
}) => {
	const [countryList, setCountryList] = useState([]);
	const dispatch = useDispatch();
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const dropdownRef = useRef();

	const handleOutSideClick = () => {
		setIsDropdownOpen(false);
	};

	useClickOutside(dropdownRef, handleOutSideClick);

	const fetchCountryList = async () => {
		try {
			dispatch(openLoader());
			const response = await getSampleCountryList();
			setCountryList(response);
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		fetchCountryList();
	}, []);

	const findCountryName = (countryId) => {
		const countryName = countryList.find((item) => item?.id === countryId);
		return countryName?.name;
	};

	const handleRemoveLocation = (countryId) => {
		const updatedList = selectedLocationsToDownload.filter(
			(item) => parseInt(item) !== parseInt(countryId)
		);
		setSelectedLocationsToDownload(updatedList);
	};

	const toggleDropdown = () => {
		setIsDropdownOpen((prev) => !prev);
	};

	const removeAll = () => {
		setSelectedLocationsToDownload([]);
	};

	return (
		<ModalContainer centered className="sample-location-modal">
			<div className="common-popup sample-location-modal">
				<div className="common-popup-header d-flex justify-content-between border-0">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Sample Location Details</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body py-0">
					<div className="row">
						<div className="col-md-12">
							<div className="select-component chip-component mb-3 show">
								<label htmlFor="collection">Country</label>
								<div className="click-box text-right click mb-1" onClick={toggleDropdown}>
									<div className="all-chips" style={{ zIndex: '2000' }} ref={dropdownRef}>
										{selectedLocationsToDownload.length > 0 ? (
											selectedLocationsToDownload.map((countryId, index) => (
												<span key={`location-${index}`}>
													{findCountryName(countryId)}
													<img
														src={`${process.env.PUBLIC_URL}/icons/chip-close.svg`}
														alt="remove"
														onClick={(e) => {
															e.stopPropagation();
															handleRemoveLocation(countryId);
														}}
													/>
												</span>
											))
										) : (
											<p className="regular-14 pl-0 gray_dark_01">Select location</p>
										)}
										<div className="close-and-down d-flex align-items-center">
											{selectedLocationsToDownload?.length > 0 && (
												<img
													src={`${process.env.PUBLIC_URL}/icons/close.svg`}
													className="close-icon cursor-pointer"
													width={24}
													onClick={() => removeAll()}
												/>
											)}
											<div>
												<img
													src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
													className="arrow-icon cursor-pointer ml-1"
												/>
											</div>
										</div>
									</div>
								</div>
								<div
									className={`dropdown-box dropdown-menu ${
										isDropdownOpen ? 'show' : 'hidden'
									}`}
								>
									<div className="list-items scroll-y-label p-3">
										{countryList.map((country) => (
											<div className="custom-chekbox" key={country?.id}>
												<div className="form-group">
													<input
														type="checkbox"
														id={`projectManager_302-${country?.id}`}
														name={`projectManager_302-${country?.id}`}
														checked={selectedLocationsToDownload.includes(
															country?.id
														)}
														onChange={() => {
															if (
																selectedLocationsToDownload.includes(
																	country?.id
																)
															) {
																setSelectedLocationsToDownload((prev) =>
																	prev.filter(
																		(location) => location !== country?.id
																	)
																);
															} else {
																setSelectedLocationsToDownload((prev) => [
																	...prev,
																	country?.id
																]);
															}
														}}
													/>
													<label htmlFor={`projectManager_302-${country?.id}`}>
														<span>{country?.name}</span>
													</label>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button
							className="button gray-outline size32"
							onClick={() => setSelectedLocationsToDownload([])}
						>
							Cancel
						</button>
						<button
							className="button size32 ml-2"
							disabled={selectedLocationsToDownload.length <= 0}
							onClick={() => downloadReportByProductIds(selectedProductIds)}
						>
							Download
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default SampleLocationDetailsModal;
